"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = exports.getFormatter = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/*
 * Get the formatter and pass it props
 * We need to do this because you can either pass an element JSX (JSX)
 * Or a type as a formatter
 */


var getFormatter = function getFormatter(formatter, props) {
  var Formatter = formatter;

  if (_react["default"].isValidElement(Formatter)) {
    // formatter was passed as an element, e.g.
    // formatter: <Formatter />
    // Clone it and pass props
    return _react["default"].cloneElement(Formatter, props);
  } else if (isFunction(Formatter)) {
    // formatter was passed as a type, e.g.
    // formatter: Formatter
    // So pass it props here
    return _react["default"].createElement(Formatter, props);
  }
};

exports.getFormatter = getFormatter;

var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
};

exports.isFunction = isFunction;